import { action, observable } from 'mobx'
import { CommentFileRequest } from '../requests/CommentFileRequest'

class CommonFileStore {
  @observable fileLists = []

  @action getCommonFileList = params => {
    return CommentFileRequest.getCommandList(params)
      .then(response => {
        this.fileLists = response.data
        return response.data
      })
      .catch(error => {
        console.error('Failed to fetch common files:', error)
        throw error
      })
  }

  @action updateFilesByUser = data => {
    return CommentFileRequest.getCommandsByUser(data)
      .then(response => {
        return response
      })
      .catch(error => {
        console.error('Failed to update files by user:', error)
        throw error
      })
  }

  /** Clear store */
  @action clearStore = () => {
    this.fileLists = []
  }
}

export default new CommonFileStore()
